module.exports = __webpack_public_path__ + "img/Middle-Bevel-Attachment-41.7f8bd6b9.png";